<template>
  <b-container>
    <b-row id="date__container">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <b-col v-bind="attrs" v-on="on">
            <DateInput
              label="Send Date"
              fieldName="sendDate"
              placeHolder="Enter the Date for the request to be sent to the Customer"
              required
              v-model="localValue.sendDate"
              :minFromToday="sendDateMinimumFromToday"
              :state="state('sendDate')"
              aria-describedby="sendDate-error"
            >
              <template v-slot:inputValidationErrors>
                <b-form-invalid-feedback
                  id="sendDate-error"
                  :forceShow="!state('sendDate')"
                >
                  {{ errors.sendDate }}
                </b-form-invalid-feedback>
              </template>
            </DateInput>
          </b-col>
        </template>
        <span>Send Date - When The Email Is Sent</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <b-col v-bind="attrs" v-on="on">
            <DateInput
              label="Expiry Date"
              fieldName="expiryDate"
              placeHolder="Enter the Expiration Date of the payment request"
              required
              v-model="localValue.expiryDate"
              :min="expiryDateMinimum"
              :state="state('expiryDate')"
              aria-describedby="expiryDate-error"
            >
              <template v-slot:inputValidationErrors>
                <b-form-invalid-feedback
                  id="expiryDate-error"
                  :forceShow="!state('expiryDate')"
                >
                  {{ errors.expiryDate }}
                </b-form-invalid-feedback>
              </template>
            </DateInput>
          </b-col>
        </template>
        <span>Expiry Date - When The Link In The Email Expires</span>
      </v-tooltip>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Payment Description" label-for="reason">
          <b-form-textarea
            id="reason"
            required
            v-model="localValue.reason"
            type="text"
            :state="state('reason')"
            aria-describedby="reason-error"
          />
          <b-form-invalid-feedback id="reason-error">
            {{ errors.reason }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DateInput from "@/components/form-elements/elements/DateInput.vue";

export default {
  components: {
    DateInput
  },
  props: {
    value: {
      sendDate: {
        type: Date,
        default: new Date()
      },
      expiryDate: {
        type: Date,
        default: new Date()
      },
      reason: {
        type: String,
        default: ""
      }
    },
    errorMessages: {
      type: Object,
      required: false,
      default() {
        return {
          sendDate: null,
          expiryDate: null,
          reason: null
        };
      }
    }
  },
  data() {
    return {
      sendDateMinimumFromToday: { year: 0, month: 0, day: 0 }
    };
  },
  watch: {
    localValue: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      }
    },
    expiryDateMinimum() {
      return this.localValue.sendDate;
    },
    errors() {
      return {
        sendDate: this.getErrorMessage("sendDate"),
        expiryDate: this.getErrorMessage("expiryDate"),
        reason: this.getErrorMessage("reason")
      };
    }
  },
  methods: {
    getErrorMessage(name) {
      return !!this.errorMessages ? this.errorMessages[name] : null;
    },
    state(name) {
      return this.errors[name] == null ? null : !this.errors[name].length;
    }
  }
};
</script>

<style lang="scss" scoped></style>
